import { render, staticRenderFns } from "./user-settings-view.vue?vue&type=template&id=4572ea20&scoped=true"
import script from "./user-settings-view.vue?vue&type=script&lang=js"
export * from "./user-settings-view.vue?vue&type=script&lang=js"
import style0 from "./user-settings-view.vue?vue&type=style&index=0&id=4572ea20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4572ea20",
  null
  
)

export default component.exports